
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/unit.js';
            vueApps['app/unit.js'] = App0;
        

            import App1 from './app/dummy.js';
            vueApps['app/dummy.js'] = App1;
        

            import App2 from './app/search.js';
            vueApps['app/search.js'] = App2;
        

            import App3 from './app/blogentry.js';
            vueApps['app/blogentry.js'] = App3;
        

            import App4 from './app/UnitsOfTheDay.js';
            vueApps['app/UnitsOfTheDay.js'] = App4;
        

            import App5 from './app/SimilarUnits.js';
            vueApps['app/SimilarUnits.js'] = App5;
        

            import App6 from './app/navbar.js';
            vueApps['app/navbar.js'] = App6;
        

            import App7 from './app/facilityListing.js';
            vueApps['app/facilityListing.js'] = App7;
        

            import App8 from './app/urlaub-mit-familie4.js';
            vueApps['app/urlaub-mit-familie4.js'] = App8;
        

            import App9 from './app/urlaub-mit-familie6.js';
            vueApps['app/urlaub-mit-familie6.js'] = App9;
        

            import App10 from './app/urlaub-mit-hund.js';
            vueApps['app/urlaub-mit-hund.js'] = App10;
        

            import App11 from './app/urlaub-mit-hund-1.js';
            vueApps['app/urlaub-mit-hund-1.js'] = App11;
        

            import App12 from './app/WustrowFamily.js';
            vueApps['app/WustrowFamily.js'] = App12;
        

            import App13 from './app/WustrowBeach.js';
            vueApps['app/WustrowBeach.js'] = App13;
        

            import App14 from './app/search-Ahrenshoop.js';
            vueApps['app/search-Ahrenshoop.js'] = App14;
        

            import App15 from './app/BornFeWo.js';
            vueApps['app/BornFeWo.js'] = App15;
        

            import App16 from './app/BornFeWo_4.js';
            vueApps['app/BornFeWo_4.js'] = App16;
        

            import App17 from './app/PrerowFeWo.js';
            vueApps['app/PrerowFeWo.js'] = App17;
        

            import App18 from './app/AhrenshoopFeWo.js';
            vueApps['app/AhrenshoopFeWo.js'] = App18;
        

            import App19 from './app/AhrenshoopStadt.js';
            vueApps['app/AhrenshoopStadt.js'] = App19;
        

            import App20 from './app/sonderangebote.js';
            vueApps['app/sonderangebote.js'] = App20;
        

            import App21 from './app/lastminute.js';
            vueApps['app/lastminute.js'] = App21;
        

            import App22 from './app/WieckFeWo.js';
            vueApps['app/WieckFeWo.js'] = App22;
        

            import App23 from './app/DierhagenFeWo.js';
            vueApps['app/DierhagenFeWo.js'] = App23;
        

            import App24 from './app/DierhagenBeach.js';
            vueApps['app/DierhagenBeach.js'] = App24;
        

        
                import Comp25 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp25);
            

                import Comp26 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp26);
            

                import Comp27 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp27);
            

                import Comp28 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp28);
            

                import Comp29 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp29);
            

                import Comp30 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp30);
            

                import Comp31 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp31);
            

                import Comp32 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp32);
            

                import Comp33 from './videoIframe.vue';
                Vue.component('video-iframe',Comp33);
            

                import Comp34 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp34);
            

                import Comp35 from './comp/seasonprices.vue';
                Vue.component('seasonprices',Comp35);
            

                import Comp36 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp36);
            

                import Comp37 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp37);
            

                import Comp38 from './comp/DateRangeExt.vue';
                Vue.component('voffice-daterange-ext',Comp38);
            

                import Comp39 from './comp/Accordion.vue';
                Vue.component('voffice-accordion',Comp39);
            

                import Comp40 from './comp/NewsletterSubsription.js';
                Vue.component('voffice-newsletter-subscription',Comp40);
            

                import Comp41 from './comp/PopupDialog.vue';
                Vue.component('voffice-popup-dlg',Comp41);
            

                import Comp42 from './imageCarousel.vue';
                Vue.component('img-carousel',Comp42);
            

                import Comp43 from './pricehelp.vue';
                Vue.component('price-help',Comp43);
            

                import Comp44 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp44);
            

                import Comp45 from './teamMember.vue';
                Vue.component('voffice-team-member',Comp45);
            

                import Comp46 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp46);
            

                import Comp47 from './comp/IncreaseNumber.vue';
                Vue.component('increase-number',Comp47);
            

                import Comp48 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp48);
            

                import Comp49 from './comp/SearchFilterTokens-v2.vue';
                Vue.component('search-filter-tokens-v2',Comp49);
            

                import Comp50 from './offershelp.vue';
                Vue.component('offer-help',Comp50);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    